import { useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { fileUrl } from "@/lib/site";
import { Button } from "@/components/ui/button";
import { CircleNotch, UploadSimple, X } from "@phosphor-icons/react";
import { toast } from "sonner";

export function OwnerPhotos({ p, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const ids = p.owner_photos || [];
  const upload = async (files) => {
    setBusy(true);
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file);
      try { await api.post(`/prospect/prospects/${p.id}/owner-photos`, fd); } catch (e) { toast.error(`${file.name}: ${apiError(e)}`); }
    }
    setBusy(false);
    onChange();
  };
  const remove = async (fid) => {
    try { await api.delete(`/prospect/prospects/${p.id}/owner-photos/${fid}`); onChange(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="space-y-2" data-testid="owner-photos">
      <p className="text-xs text-muted-foreground">Só fotos enviadas pelo próprio restaurante. As restantes vêm do Google Places, com atribuição. Volte a correr o Designer depois de adicionar.</p>
      {ids.length > 0 && (
        <div className="flex flex-wrap gap-2">{ids.map((id) => (
          <div key={id} className="relative h-16 w-16 overflow-hidden rounded-lg border">
            <img src={fileUrl(id)} alt="" className="h-full w-full object-cover" />
            <button onClick={() => remove(id)} aria-label="Remover foto" className="absolute right-0.5 top-0.5 rounded-full bg-black/60 p-1 text-white" data-testid={`owner-photo-remove-${id}`}><X size={12} /></button>
          </div>
        ))}</div>
      )}
      <input ref={ref} type="file" accept="image/*" multiple hidden onChange={(e) => { upload([...e.target.files]); e.target.value = ""; }} data-testid="owner-photos-input" />
      <Button size="sm" variant="outline" disabled={busy || ids.length >= 12} onClick={() => ref.current?.click()} data-testid="owner-photos-upload-btn">
        {busy ? <CircleNotch className="mr-1 animate-spin" /> : <UploadSimple className="mr-1" />} Adicionar fotos do restaurante
      </Button>
    </div>
  );
}
